import React from 'react'
import PropTypes from 'prop-types'
import { Offcanvas, OffcanvasHeader, OffcanvasBody } from 'reactstrap'
import classNames from 'classnames'

export const Drawer = ({
  visible = false,
  children,
  header = true,
  onClose,
  onClosed,
  className = '',
  title,
  renderTitle,
  ...props
}) => {
  return (
    <Offcanvas
      isOpen={visible}
      toggle={onClose}
      onClosed={onClosed}
      className={className}
      {...props}
    >
      {header && (
        <OffcanvasHeader toggle={onClose}>
          {renderTitle ? renderTitle() : title ? renderTitle() : null}
        </OffcanvasHeader>
      )}
      <OffcanvasBody>{children}</OffcanvasBody>
    </Offcanvas>
  )
}

Drawer.propTypes = {
  visible: PropTypes.bool,
  children: PropTypes.any,
  header: PropTypes.bool,
  title: PropTypes.string,
  renderTitle: PropTypes.func,
  onClose: PropTypes.func,
  onClosed: PropTypes.func,
  className: PropTypes.string,
}
